import React from 'react'
import { useParams } from 'react-router-dom'

export default function CostCodeDetails() {
    const { id, costCodeId } = useParams()
    // const { data } = useGetAllCostCodes('cost-codes', id)
    return (
        <>
            <div>CostCode Details</div>
        </>
    )
}
